if (!customElements.get('signature-fit-filters')) {
  class SignatureFitFilters extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-fit-filter]'));
      this.grid = this.resolveGrid();
      this.countTargets = this.resolveCounts();
      this.mode = this.dataset.mode || 'client';
      this.param = this.dataset.param || '';
      this.emptyState = this.resolveEmpty();

      this.pills.forEach((pill) => {
        pill.addEventListener('click', (event) => {
          event.preventDefault();
          this.select(pill);
        });
      });

      this.querySelectorAll('.sort-close').forEach((close) => {
        close.addEventListener('click', (event) => event.stopPropagation());
      });
      this.querySelectorAll('.sort-listbox').forEach((listbox) => {
        listbox.addEventListener('click', (event) => event.stopPropagation());
      });

      if (this.grid && this.mode !== 'storefront') {
        this.observer = new MutationObserver(() => this.applyClientFilter());
        this.observer.observe(this.grid, { childList: true, subtree: true });
      }

      document.addEventListener('collection:reloaded', this.onCollectionReloaded);

      if (this.mode !== 'storefront') {
        this.syncFromUrl();
        this.applyClientFilter();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('collection:reloaded', this.onCollectionReloaded);
    }

    onCollectionReloaded = () => {
      this.grid = this.resolveGrid();
      this.countTargets = this.resolveCounts();
      this.emptyState = this.resolveEmpty();
      if (this.mode !== 'storefront') this.applyClientFilter();
    };

    resolveGrid() {
      const selector = this.dataset.gridSelector;
      const root = this.closest('.shopify-section') || document;
      if (selector) {
        return root.querySelector(selector) || document.querySelector(selector);
      }
      return document.getElementById('ProductGridContainer');
    }

    resolveEmpty() {
      const root = this.closest('.shopify-section') || document;
      return root.querySelector('[data-fit-empty]');
    }

    resolveCounts() {
      const selector = this.dataset.countSelector || '[data-fit-count]';
      const root = this.closest('.shopify-section') || document;
      return Array.from(root.querySelectorAll(selector));
    }

    select(pill) {
      if (pill.getAttribute('aria-pressed') === 'true') return;

      this.pills.forEach((item) => {
        const isActive = item === pill;
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        item.classList.toggle('is-active', isActive);
      });

      const value = pill.dataset.fitValue || '';
      const storefrontValue = pill.dataset.storefrontValue || value;

      if (this.mode === 'storefront' && this.param) {
        this.applyStorefront(storefrontValue);
        return;
      }

      this.updateClientUrl(value);
      this.applyClientFilter();
    }

    applyStorefront(value) {
      const form =
        this.closest('form[is="facet-form"]') ||
        document.querySelector('form[is="facet-form"]');
      const url = new URL(window.location.href);

      url.searchParams.delete('page');
      Array.from(url.searchParams.keys()).forEach((key) => {
        if (key === this.param || key.startsWith(`${this.param}.`)) {
          url.searchParams.delete(key);
        }
      });

      if (value) url.searchParams.set(this.param, value);

      if (form && typeof form.renderSection === 'function') {
        url.searchParams.set('section_id', theme.utils.sectionId(form));
        form.dirty = true;
        form.renderSection(url.toString());
        return;
      }

      url.searchParams.delete('section_id');
      window.location.assign(url.toString());
    }

    updateClientUrl(value) {
      const url = new URL(window.location.href);
      if (value) {
        url.searchParams.set('fit', value);
      } else {
        url.searchParams.delete('fit');
      }
      history.replaceState({}, '', url.toString());
    }

    syncFromUrl() {
      const current = new URLSearchParams(window.location.search).get('fit') || '';
      if (!current) return;

      const match = this.pills.find((pill) => {
        const value = pill.dataset.fitValue || '';
        return this.normalize(value) === this.normalize(current);
      });

      if (!match) return;

      this.pills.forEach((item) => {
        const isActive = item === match;
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        item.classList.toggle('is-active', isActive);
      });
    }

    applyClientFilter() {
      if (!this.grid) return;

      const active = this.querySelector('[data-fit-filter][aria-pressed="true"]');
      const filterValue = active ? active.dataset.fitValue || '' : '';
      const cards = this.grid.querySelectorAll('.product-card[data-signature-fit]');
      let visible = 0;

      cards.forEach((card) => {
        const match = this.matchesFit(card.dataset.signatureFit || '', filterValue);
        card.classList.toggle('is-fit-hidden', !match);
        if (match) visible += 1;
      });

      this.updateCount(visible);
      if (this.emptyState) {
        this.emptyState.hidden = visible > 0 || cards.length === 0;
      }
    }

    matchesFit(productFits, filterValue) {
      if (!filterValue) return true;
      const needle = this.normalize(filterValue);
      return String(productFits)
        .split('|')
        .some((fit) => {
          const hay = this.normalize(fit);
          if (!hay) return false;
          return hay === needle || hay.includes(needle) || needle.includes(hay);
        });
    }

    normalize(value) {
      return String(value)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    updateCount(count) {
      if (!this.countTargets.length) return;
      const template =
        count === 1
          ? this.dataset.countOne || 'Showing __COUNT__ product'
          : this.dataset.countOther || 'Showing __COUNT__ products';
      const label = template.replace('__COUNT__', String(count));
      this.countTargets.forEach((target) => {
        target.textContent = label;
      });
    }
  }

  customElements.define('signature-fit-filters', SignatureFitFilters);
}
